module.exports = __webpack_public_path__ + "img/bianjie6.79be7b8d.png";